import { useEffect, useState } from 'react';
import type { VoiceSessionState } from './hooks/useVoiceSession';

export function LandscapeDriveCockpitHalo({ state }: { state: VoiceSessionState }) {
    const [warning, setWarning] = useState(false);

    useEffect(() => {
        if (state.status !== 'speaking' || state.speakingKind !== 'canned') {
            setWarning(false);
            return;
        }
        setWarning(true);
        const t = window.setTimeout(() => setWarning(false), 400);
        return () => window.clearTimeout(t);
    }, [state.status, state.speakingKind, state.error]);

    const variant = haloVariant(state, warning);
    if (variant === 'idle') return null;

    return (
        <div
            aria-hidden="true"
            data-voice-halo={variant}
            className={`pointer-events-none absolute inset-[-18px] rounded-[28px] border-2 ${haloClass(variant)}`}
        />
    );
}

function haloVariant(state: VoiceSessionState, warning: boolean): 'idle' | 'listening' | 'thinking' | 'speaking' | 'warning' | 'canned' {
    if (warning) return 'warning';
    if (state.status === 'listening') return 'listening';
    if (state.status === 'thinking') return 'thinking';
    if (state.status === 'speaking' && state.speakingKind === 'normal') return 'speaking';
    if (state.status === 'speaking' && state.speakingKind === 'canned') return 'canned';
    return 'idle';
}

function haloClass(variant: Exclude<ReturnType<typeof haloVariant>, 'idle'>): string {
    switch (variant) {
        case 'listening':
            return 'animate-pulse border-cyan-300 shadow-[0_0_34px_rgba(103,232,249,0.75)]';
        case 'thinking':
            return 'animate-pulse border-white/25 shadow-[0_0_22px_rgba(255,255,255,0.22)]';
        case 'speaking':
            return 'border-brand shadow-[0_0_34px_rgb(77_141_255_/_0.72)]';
        case 'warning':
            return 'border-amber-300 shadow-[0_0_34px_rgba(252,211,77,0.72)]';
        case 'canned':
            return 'border-amber-200/70 shadow-[0_0_26px_rgba(252,211,77,0.34)]';
    }
}

